"use client";
import styles from "@/app/styles/content.module.scss";
import dataSet from "@/data/services";
import { useState, useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Section4 = () => {
  const sectionRef = useRef(null);
  const headerRef = useRef(null);
  const cardFirstRef = useRef(null);
  const cardLastRef = useRef(null);
  useGSAP(
    () => {
      gsap.fromTo(
        headerRef.current,
        { opacity: 0, y: -50 },
        {
          opacity: 1,
          y: 0,
          duration: 1.5,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            end: "bottom 20%",
            toggleActions: "play none none none",
          },
        }
      );
      gsap.fromTo(
        cardFirstRef.current,
        { opacity: 0, x: -50 },
        {
          opacity: 1,
          x: 0,
          duration: 1.5,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 60%",
            end: "bottom 20%",
            toggleActions: "play none none none",
          },
        }
      );
      gsap.fromTo(
        cardLastRef.current,
        { opacity: 0, x: 50 },
        {
          opacity: 1,
          x: 0,
          duration: 1.5,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 60%",
            end: "bottom 20%",
            toggleActions: "play none none none",
          },
        }
      );
    },
    { scope: sectionRef }
  );
  const [activeIndex, setActiveIndex] = useState(0);

  const filteredData = (dataSet.services || [])
    .filter((item) => item.pin === true)
    .sort((a, b) => a.id - b.id)
    .slice(0, 4);

  const handleHover = (index) => setActiveIndex(index);
  // const handleLeave = () => setActiveIndex(null);

  return (
    <section className={styles.section4} ref={sectionRef}>
      <div className={styles.header_section4} ref={headerRef}>
        <h1 className={`header`}>
          <div>We design spaces where nature flows to your senses.</div>
        </h1>
        <div className="flex flex-col items-center my-8 px-[5vw]">
          <p className="font-[500] text-[32px] text-center w-[70vw] mb-6">
            “เราเชื่อว่าธรรมชาติไม่ใช่แค่สิ่งที่มองเห็น
            แต่คือความรู้สึกที่ได้สัมผัส”
          </p>
          <hr className="w-[60px] h-[2px] text-[#DDDDDD]" />
          <p className="text-[24px] text-center mt-6 w-[70vw]">
            Cozyscape ออกแบบมุมธรรมชาติที่โอบกอดหัวใจของคุณ
            ผ่านเสียงน้ำที่แผ่วเบา
            <br />
            ลำธารที่ไหลเอื่อย และบ่อปลาที่สงบงาม
            เพื่อให้คุณได้ใช้เวลากับความสุขที่เรียบง่ายอย่างแท้จริง
          </p>
        </div>
      </div>

      <div className={styles.dataWrapper}>
        {filteredData.map((data, i) => {
          const isExpanded = activeIndex === i;
          const isShrunk = activeIndex !== null && activeIndex !== i;

          return (
            <div
              key={data.id}
              className={`${styles.cardLink} ${
                isExpanded ? styles.expanded : ""
              } ${isShrunk ? styles.shrunk : ""}`}
              onMouseEnter={() => handleHover(i)}
              ref={
                i === 0
                  ? cardFirstRef
                  : i === filteredData.length - 1
                  ? cardLastRef
                  : null
              }
            >
              <div className={styles.cardWithPhoto}>
                <div
                  className={styles.backgroundLayer}
                  style={{ backgroundImage: `url(${data.image})` }}
                ></div>
                {/* <button className={styles.viewMore}>ดูเพิ่มเติม</button> */}
                <div className={styles.content}>
                  <p>{data.header}</p>
                  <h2>{data.description}</h2>
                </div>
              </div>
            </div>
          );
        })}

        {/* Maintenance Card */}
        {/* <div
          // href={`/services/maintenance`}
          ref={cardLastRef}
          className={`${styles.cardLink} ${
            activeIndex === filteredData.length ? styles.expanded : ""
          } ${
            activeIndex !== null && activeIndex !== filteredData.length
              ? styles.shrunk
              : ""
          }`}
          onMouseEnter={() => handleHover(filteredData.length)}
          // onMouseLeave={handleLeave}
        >
          <div className={styles.cardWithPhoto}>
            <div
              className={styles.backgroundLayer}
              style={{ backgroundImage: `url(/Services/swim-pond.webp)` }}
            ></div>
            <button className={styles.viewMore}>ดูเพิ่มเติม</button>
            <div className={styles.content}>
              <p>สระว่ายน้ำธรรมชาติ</p>
              <h2>SWIMMING<br/>PONDS</h2>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Section4;
